module.exports = __webpack_public_path__ + "img/book-placeholder.610fde24.jpg";